export default "__VITE_ASSET__CT7$lIMF__"